import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../../shared/utils';

export default function BlogCard({ post, featured = false }) {
  const initials = (post.authorName || 'A')[0].toUpperCase();
  const postUrl = `/blog/${post.slug}`;

  if (featured) {
    return (
      <Link to={postUrl} className="u-card-featured">
        <div className="u-card-featured-image">
          {post.coverImage ? (
            <img src={post.coverImage} alt={post.title} loading="lazy" />
          ) : (
            <div className="u-no-cover" style={{ aspectRatio: '4/3' }}>📝</div>
          )}
        </div>
        <div className="u-card-featured-body">
          <div className="u-card-featured-label">
            <span>⭐</span> Featured Post
            {post.category && (
              <span style={{ fontWeight: 400, color: 'inherit', opacity: .7 }}>
                &nbsp;·&nbsp;{post.category}
              </span>
            )}
          </div>
          <h2 className="u-card-featured-title">{post.title}</h2>
          {post.excerpt && (
            <p className="u-card-featured-excerpt">{post.excerpt}</p>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, fontSize: 13, color: '#94a3b8' }}>
            <span>{post.authorName || 'Author'}</span>
            <span className="u-card-dot" />
            <span>{formatDate(post.publishedAt)}</span>
            {post.readTime && (
              <>
                <span className="u-card-dot" />
                <span>{post.readTime} min read</span>
              </>
            )}
          </div>
          <span className="u-read-more">Read article →</span>
        </div>
      </Link>
    );
  }

  return (
    <Link to={postUrl} className="u-card">
      <div className="u-card-image-wrap">
        {post.coverImage ? (
          <img src={post.coverImage} alt={post.title} className="u-card-image" loading="lazy" />
        ) : (
          <div className="u-card-image-placeholder">📝</div>
        )}
        {post.category && (
          <span className="u-card-category">{post.category}</span>
        )}
      </div>

      <div className="u-card-body">
        <h3 className="u-card-title">{post.title}</h3>
        {post.excerpt && <p className="u-card-excerpt">{post.excerpt}</p>}

        <div className="u-card-meta">
          <div className="u-card-author-avatar">{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="u-card-author-name">{post.authorName || 'Author'}</div>
          </div>
          <span className="u-card-dot" />
          <span style={{ whiteSpace: 'nowrap' }}>{formatDate(post.publishedAt)}</span>
          {post.readTime && (
            <>
              <span className="u-card-dot" />
              <span className="u-card-read-time">⏱ {post.readTime}m</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}
